<template>
  <div class="dashboard-new-container">
    <!-- Top Bar -->
    <div class="top-bar">
      <div class="info-group">
        <span class="info-text">人数上限: <strong class="num-text">{{ sysUsedPerson.total }}</strong></span>
        <span class="tag-upgrade">升级</span>
        <span class="info-text ml-40">已加入人数: <strong class="num-text">{{ sysUsedPerson.joined }}</strong></span>
        <a-button type="primary" size="small" class="ml-10 btn-add" @click="goTo('/AddDinner')">添加人员</a-button>
        
        <div class="audit-warning ml-40" v-if="pendingAppsCount > 0">
          <a-icon type="exclamation-circle" theme="filled" class="warning-icon" />
          <span class="warning-text">存在{{ pendingAppsCount }}条待审核申请</span>
          <a-button type="link" size="small" class="btn-process" @click="goTo('/PersonInfoManage')">去处理</a-button>
        </div>
      </div>
      <a-button type="link" class="btn-switch" @click="$emit('switchVersion')">查看旧版</a-button>
    </div>

    <!-- Cards Row -->
    <div class="nav-cards">
      <div class="nav-card" @click="goTo('/PersonInfoManage')">
        <div class="icon-circle bg-orange-light"><a-icon type="team" class="icon-orange" /></div>
        <span class="nav-text">人员管理</span>
      </div>
      <div class="nav-card" @click="goTo('/MealDetail')">
        <div class="icon-circle bg-blue-light"><a-icon type="profile" class="icon-blue" /></div>
        <span class="nav-text">报餐明细</span>
      </div>
      <div class="nav-card" @click="goTo('/NoticesManage')">
        <div class="icon-circle bg-green-light"><a-icon type="bell" class="icon-green" /></div>
        <span class="nav-text">食堂公告</span>
      </div>
      <div class="nav-card" @click="goToAccountRecharge">
        <div class="icon-circle bg-purple-light"><a-icon type="wallet" class="icon-purple" /></div>
        <span class="nav-text">账户充值</span>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <div class="left-column">
        <!-- 用餐概览 -->
        <div class="content-box">
          <div class="box-header">
            <div class="box-title">用餐概览 <span class="box-subtitle">（数据口径：订单数，更多数据可在"报餐明细"中查看）</span></div>
            <a-radio-group v-model="overviewTime" class="custom-radio" :disabled="loadingOverview">
              <a-radio-button value="yesterday">昨天</a-radio-button>
              <a-radio-button value="today">今天</a-radio-button>
              <a-radio-button value="month">本月</a-radio-button>
              <a-radio-button value="lastMonth">上月</a-radio-button>
            </a-radio-group>
          </div>
          <a-spin :spinning="loadingOverview">
            <div class="overview-stats">
              <div class="stat-card">
                <div class="stat-value text-orange">{{ useDinnerCase.apply_dinners }}</div>
                <div class="stat-label">报餐数</div>
              </div>
              <div class="stat-card">
                <div class="stat-value text-orange">{{ useDinnerCase.used_dinner }}</div>
                <div class="stat-label">实际就餐数</div>
              </div>
              <div class="stat-card">
                <div class="stat-value text-orange">{{ useDinnerCase.returned_dinner }}</div>
                <div class="stat-label">退餐数</div>
              </div>
              <div class="stat-card">
                <div class="stat-value text-orange">{{ useDinnerCase.meal_rate }}</div>
                <div class="stat-label">就餐率</div>
              </div>
            </div>
          </a-spin>
        </div>

        <!-- 报餐统计 -->
        <div class="content-box mt-20" style="flex: 1;">
          <div class="box-header">
            <div class="box-title">报餐统计 <span class="box-subtitle">（数据口径：订单数，更多数据可在"报餐明细"中查看）</span></div>
          </div>
          <a-spin :spinning="loadingMeal" style="flex: 1; display: flex; flex-direction: column;justify-content: center;">
            <div v-if="mealReportNoData" class="meal-empty">暂无数据</div>
            <div v-else class="meal-stats-columns">
              <div class="meal-row-labels">
                <div class="meal-label-empty"></div>
                <div class="meal-label" v-for="(label, i) in mealReport.labels" :key="'label_'+i">{{ label }}</div>
              </div>
              <div class="meal-column bg-orange">
                <div class="meal-col-header">昨天</div>
                <div class="meal-cell" v-for="(val, i) in mealReport.yesterday" :key="'y_'+i">{{ val }}</div>
              </div>
              <div class="meal-column bg-green">
                <div class="meal-col-header">今天</div>
                <div class="meal-cell" v-for="(val, i) in mealReport.today" :key="'t_'+i">{{ val }}</div>
              </div>
              <div class="meal-column bg-blue">
                <div class="meal-col-header">明天</div>
                <div class="meal-cell" v-for="(val, i) in mealReport.tomorrow" :key="'m_'+i">{{ val }}</div>
              </div>
            </div>
          </a-spin>
        </div>
      </div>

      <div class="right-column">
        <!-- 营收统计 -->
        <div class="content-box h-full">
          <div class="box-header">
            <div class="box-title">营收统计</div>
            <a-radio-group v-model="overviewTime" class="custom-radio" :disabled="loadingOverview">
              <a-radio-button value="yesterday">昨天</a-radio-button>
              <a-radio-button value="today">今天</a-radio-button>
              <a-radio-button value="month">本月</a-radio-button>
              <a-radio-button value="lastMonth">上月</a-radio-button>
            </a-radio-group>
          </div>
          <a-spin :spinning="loadingOverview" style="flex: 1;">
            <div style="display: flex; flex-direction: column; height: 100%;">
              <div class="revenue-total">
                营收金额：<span class="text-orange revenue-amount">¥{{ revenueAmount }}</span>
              </div>
              <div class="revenue-chart-title">营收分布</div>
              <div class="revenue-chart">
                <My-echart :id="'revenueChart'" :echartOption="revenueOption" style="height: 350px; width: 100%;" />
              </div>
            </div>
          </a-spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyEchart from "@/components/common/MyEchart.vue";
import { getSysInfo, getMealReportCount, getUseDinnerCase, happlyIndex } from "@/request/api";
import moment from "moment";

export default {
  name: "DashboardNew",
  components: {
    MyEchart
  },
  data() {
    return {
      pendingAppsCount: 0,
      loadingOverview: false,
      loadingMeal: false,
      overviewTime: "yesterday",
      revenueAmount: "0.00",
      sysUsedPerson: {
        total: 0,
        joined: 0
      },
      useDinnerCase: {
        apply_dinners: 0,
        used_dinner: 0,
        returned_dinner: 0,
        goods_money: 0,
        scan_money: 0,
        checkout_money: 0,
        meal_rate: "0%"
      },
      mealReportNoData: false,
      mealReport: {
        yesterday: [0, 0, 0, 0],
        today: [0, 0, 0, 0],
        tomorrow: [0, 0, 0, 0],
        labels: ["早餐", "午餐", "晚餐", "宵夜"]
      },
      revenueOption: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          bottom: '0',
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: '#666'
          }
        },
        series: [
          {
            type: 'pie',
            radius: '70%',
            center: ['50%', '45%'],
            label: {
              formatter: '{c}\n{d}%',
              color: '#fff',
              position: 'inner'
            },
            data: [
              { value: 1791.35, name: '报餐' },
              { value: 423.41, name: '小卖部' },
              { value: 651.40, name: '消费二维码' },
              { value: 390.84, name: '收银' }
            ],
            itemStyle: {
              borderWidth: 0
            }
          }
        ]
      }
    };
  },
  watch: {
    overviewTime() {
      this.getUseDinnerCaseFn();
    }
  },
  created() {
    this.getSysInfoFn();
    this.getUseDinnerCaseFn();
    this.getMealReportFn();
    this.getPendingAppsCountFn();
  },
  methods: {
    async getPendingAppsCountFn() {
      try {
        const params = {
          page: 1,
          created_start: "",
          created_end: "",
          nickname: "",
          mobile: "",
          realname: "",
          status: 1,
          office_id: "",
          post_id: ""
        };
        const res = await happlyIndex(params);
        if (res && res.data && typeof res.data.total !== 'undefined') {
          this.pendingAppsCount = res.data.total;
        }
      } catch (err) {
        console.error(err);
      }
    },
    goTo(path) {
      this.$router.push(path);
    },
    readLocalArray(key) {
      try {
        let raw = localStorage.getItem(key);
        let parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        return [];
      }
    },
    hasAccountRechargeAuth() {
      let useAuth = this.readLocalArray('useAuth');
      let useRouter = this.readLocalArray('useRouter');

      let hasByUseAuth = useAuth.some(item => item && (item.name === '账户充值' || String(item.id) === '8'));
      if (hasByUseAuth) {
        return true;
      }

      let accountManageRoute = useRouter.find(item => item && (item.path === '/accountManage' || item.name === '账户管理'));
      if (!accountManageRoute || accountManageRoute.meta?.show === false) {
        return false;
      }

      let children = Array.isArray(accountManageRoute.children) ? accountManageRoute.children : [];
      return children.some(child => {
        if (!child) {
          return false;
        }
        let isTarget = child.path === '/AccountRecharge' || child.name === '账户充值';
        let hasAuth = child.meta ? child.meta.requireAuth !== false : true;
        return isTarget && hasAuth;
      });
    },
    goToAccountRecharge() {
      if (!this.hasAccountRechargeAuth()) {
        this.$message.warning('暂未开通虚拟账户功能，请开通后继续使用');
        return;
      }
      this.goTo('/AccountRecharge');
    },
    async getSysInfoFn() {
      try {
        let { data } = await getSysInfo();
        this.sysUsedPerson.total = data.sysUsedPerson.total;
        let usedItem = data.sysUsedPerson.data.find(item => item.name === '已用人数');
        this.sysUsedPerson.joined = usedItem ? usedItem.value : 0;
      } catch (err) {
        console.error(err);
      }
    },
    async getUseDinnerCaseFn() {
      this.loadingOverview = true;
      let start_date = '', end_date = '', type = 1;
      if (this.overviewTime === 'yesterday') {
        start_date = moment().subtract(1, 'days').format('YYYY-MM-DD');
        type = 1;
      } else if (this.overviewTime === 'today') {
        start_date = moment().format('YYYY-MM-DD');
        type = 1;
      } else if (this.overviewTime === 'month') {
        start_date = moment().format('YYYY-MM');
        type = 3;
      } else if (this.overviewTime === 'lastMonth') {
        start_date = moment().subtract(1, 'months').format('YYYY-MM');
        type = 3;
      }
      
      try {
        let { data } = await getUseDinnerCase({ type, start_date, end_date });
        if (data && data.length != 0 && data.usedDinnerCase) {
          let used = data.usedDinnerCase.used_dinner || 0;
          let returned = data.usedDinnerCase.returned_dinner || 0;
          let apply = (data.usedDinnerCase.apply_dinner || 0) + returned;
          
          this.useDinnerCase.apply_dinners = apply;
          this.useDinnerCase.used_dinner = used;
          this.useDinnerCase.returned_dinner = returned;
          this.useDinnerCase.meal_rate = apply > 0 ? ((used / apply) * 100).toFixed(2) + '%' : '0%';
        } else {
          this.useDinnerCase = {
            apply_dinners: 0,
            used_dinner: 0,
            returned_dinner: 0,
            meal_rate: "0%"
          };
        }

        // 处理营收统计数据
        let rTotal = parseFloat(data?.total || data?.usedDinnerCase?.total || 0);
        let rGoods = parseFloat(data?.goods_money || data?.usedDinnerCase?.goods_money || 0);
        let rScan = parseFloat(data?.scan_money || data?.usedDinnerCase?.scan_money || 0);
        let rCheckout = parseFloat(data?.checkout_money || data?.usedDinnerCase?.checkout_money || 0);
        
        let sum = rTotal + rGoods + rScan + rCheckout;
        this.revenueAmount = sum.toFixed(2);
        
        let newOption = JSON.parse(JSON.stringify(this.revenueOption));
        let chartData = [
          { value: rTotal > 0 ? rTotal : 0, name: '报餐', itemStyle: { color: '#4b74e0' } },
          { value: rGoods > 0 ? rGoods : 0, name: '小卖部', itemStyle: { color: '#6ccb73' } },
          { value: rScan > 0 ? rScan : 0, name: '消费二维码', itemStyle: { color: '#f6c04f' } },
          { value: rCheckout > 0 ? rCheckout : 0, name: '收银', itemStyle: { color: '#ef6555' } }
        ];
        newOption.series[0].data = chartData.filter(item => item.value > 0);
        this.revenueOption = newOption;

      } catch (err) {
        console.error(err);
      } finally {
        this.loadingOverview = false;
      }
    },
    async getMealReportFn() {
      this.loadingMeal = true;
      try {
        let yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        let today = moment().format('YYYY-MM-DD');
        let tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');

        let { data } = await getMealReportCount({ start_date: yesterday, end_date: tomorrow });
        if (!data || !Array.isArray(data.data) || data.data.length === 0) {
          this.mealReportNoData = true;
          this.mealReport.labels = [];
          this.mealReport.yesterday = [];
          this.mealReport.today = [];
          this.mealReport.tomorrow = [];
          return;
        }

        let allItemsMap = new Map();
        let mapY = {}, mapT = {}, mapM = {};
        
        let idxY = -1, idxT = -1, idxM = -1;
        if (data && data.time) {
          idxY = data.time.indexOf(yesterday);
          idxT = data.time.indexOf(today);
          idxM = data.time.indexOf(tomorrow);
        }

        if (data && data.data) {
          data.data.forEach(item => {
            let key = item.name + (item.batch || '');
            if (!allItemsMap.has(key)) {
              allItemsMap.set(key, {
                name: item.name,
                batch: item.batch || '',
                is_valid: item.is_valid !== undefined ? item.is_valid : 1,
                title: item.name + (item.batch || '')
              });
            }
            if (!mapY[key]) mapY[key] = 0;
            if (!mapT[key]) mapT[key] = 0;
            if (!mapM[key]) mapM[key] = 0;
            
            if (idxY !== -1 && item.data[idxY]) mapY[key] += item.data[idxY];
            if (idxT !== -1 && item.data[idxT]) mapT[key] += item.data[idxT];
            if (idxM !== -1 && item.data[idxM]) mapM[key] += item.data[idxM];
          });
        }

        let labelsArr = Array.from(allItemsMap.values());

        // 如果is_valid为0，且全部value为0，则隐藏此项
        labelsArr = labelsArr.filter(item => {
          let key = item.name + item.batch;
          let totalValue = (mapY[key] || 0) + (mapT[key] || 0) + (mapM[key] || 0);
          if (item.is_valid === 0 && totalValue === 0) {
            return false;
          }
          return true;
        });

        // 统计过滤后每个name的出现次数，如果某种分类没有数据（被隐藏），剩下的那一项就不显示batch
        let nameCount = {};
        labelsArr.forEach(item => {
          if (!nameCount[item.name]) nameCount[item.name] = 0;
          nameCount[item.name]++;
        });

        labelsArr.forEach(item => {
          if (nameCount[item.name] === 1) {
            item.title = item.name;
          } else {
            item.title = item.name + item.batch;
          }
        });

        // 排序：优先按早中晚夜的顺序，然后再按名称字典序
        const standardOrder = ["早餐", "午餐", "晚餐", "宵夜"];
        labelsArr.sort((a, b) => {
          let idxA = standardOrder.indexOf(a.name.replace(/[0-9]/g, ''));
          let idxB = standardOrder.indexOf(b.name.replace(/[0-9]/g, ''));
          if (idxA !== -1 && idxB !== -1) {
            if (idxA === idxB) return a.title.localeCompare(b.title);
            return idxA - idxB;
          }
          if (idxA !== -1) return -1;
          if (idxB !== -1) return 1;
          return a.title.localeCompare(b.title);
        });

        if (labelsArr.length === 0) {
          this.mealReportNoData = true;
          this.mealReport.labels = [];
          this.mealReport.yesterday = [];
          this.mealReport.today = [];
          this.mealReport.tomorrow = [];
          return;
        }

        let yesterdayData = labelsArr.map(item => mapY[item.name + item.batch] || 0);
        let todayData = labelsArr.map(item => mapT[item.name + item.batch] || 0);
        let tomorrowData = labelsArr.map(item => mapM[item.name + item.batch] || 0);
        let labels = labelsArr.map(item => item.title);

        this.mealReport.labels = labels;
        this.mealReport.yesterday = yesterdayData;
        this.mealReport.today = todayData;
        this.mealReport.tomorrow = tomorrowData;
        this.mealReportNoData = false;
      } catch (err) {
        this.mealReportNoData = true;
        this.mealReport.labels = [];
        this.mealReport.yesterday = [];
        this.mealReport.today = [];
        this.mealReport.tomorrow = [];
        console.error(err);
      } finally {
        this.loadingMeal = false;
      }
    }
  }
};
</script>

<style scoped>
.dashboard-new-container {
  padding: 20px 20px 20px 0;
  background-color: #f0f2f5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-bottom: 20px;
}

.info-group {
  display: flex;
  align-items: center;
}

.info-text {
  font-size: 14px;
  color: #333;
}

.num-text {
  font-size: 16px;
  color: #000;
  font-weight: bold;
}

.tag-upgrade {
  background-color: #fff3e0;
  color: #fa8c16;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 8px;
  cursor: pointer;
}

.ml-40 { margin-left: 40px; }
.ml-20 { margin-left: 20px; }
.ml-10 { margin-left: 10px; }
.mt-20 { margin-top: 20px; }
.h-full { height: 100%; }

.btn-add {
  background-color: #e6f7ff;
  color: #1890ff;
  border-color: #91d5ff;
  border-radius: 4px;
}

.audit-warning {
  display: flex;
  align-items: center;
  background-color: #fffbe6;
  padding: 4px 16px;
  border-radius: 16px;
}

.warning-icon {
  color: #faad14;
  margin-right: 8px;
}

.warning-text {
  color: #666;
  font-size: 14px;
}

.btn-process {
  color: #1890ff;
  padding: 0 8px;
}

.btn-switch {
  color: #1890ff;
}

.nav-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.nav-card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-right: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.nav-card:last-child {
  margin-right: 0;
}

.nav-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 24px;
}

.bg-orange-light { background-color: #fff2e8; }
.icon-orange { color: #fa8c16; }

.bg-blue-light { background-color: #e6f7ff; }
.icon-blue { color: #1890ff; }

.bg-green-light { background-color: #f6ffed; }
.icon-green { color: #52c41a; }

.bg-purple-light { background-color: #f9f0ff; }
.icon-purple { color: #722ed1; }

.nav-text {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}

.main-content {
  display: flex;
  align-items: stretch;
}

.left-column {
  flex: 2;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}

.right-column {
  flex: 1;
}

.content-box {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.box-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.box-subtitle {
  font-size: 12px;
  font-weight: normal;
  color: #999;
}

::v-deep .custom-radio .ant-radio-button-wrapper {
  border-radius: 4px;
  margin-left: 8px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
}

::v-deep .custom-radio .ant-radio-button-wrapper:first-child {
  margin-left: 0;
}

::v-deep .custom-radio .ant-radio-button-wrapper-checked {
  background: #fff2e8 !important;
  border-color: #fa8c16 !important;
  border-left-color: #fa8c16 !important;
  color: #fa8c16 !important;
  box-shadow: none !important;
}

::v-deep .custom-radio .ant-radio-button-wrapper:hover {
  color: #fa8c16;
  border-color: #fa8c16;
}

::v-deep .custom-radio .ant-radio-button-wrapper:focus-within {
  box-shadow: none !important;
}

::v-deep .custom-radio .ant-radio-button-wrapper::before {
  display: none !important;
}

.overview-stats {
  display: flex;
  justify-content: space-between;
}

.stat-card {
  flex: 1;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 24px 0;
  text-align: center;
  margin-right: 16px;
}

.stat-card:last-child {
  margin-right: 0;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 8px;
}

.text-orange {
  color: #fa8c16;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.meal-stats-columns {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  flex: 1;
}

.meal-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d3d3d3;
  font-size: 20px;
}

.meal-row-labels {
  display: flex;
  flex-direction: column;
  width: 200px;
}

.meal-label-empty {
  height: 40px;
  margin-bottom: 16px;
}

.meal-label {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
  font-weight: bold;
}

.meal-column {
  flex: 1;
  max-width: 120px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  color: #fff;
}

.bg-orange { background-color: #ff9c00; }
.bg-green { background-color: #4bc7a6; }
.bg-blue { background-color: #55b2d2; }

.meal-col-header {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 24px;
}

.meal-cell {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-bottom: 16px;
}

.revenue-total {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 24px;
}

.revenue-amount {
  font-size: 20px;
}

.revenue-chart-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.revenue-chart {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
